import { confirm, notification, message as pcMessage } from '@ts-max/antd';
import { type ErrorTip, ErrorTipMode } from '@ts-max/axios';
import { t } from 'i18next';
import { isValidElement, type ReactNode } from 'react';

export function showError(options: ErrorTip | string | ReactNode | Error) {
  if (!options) return;

  let title = t('common:error');
  let mode = ErrorTipMode.message;
  let message: ReactNode | string | undefined;

  if (typeof options === 'string') {
    message = options;
  }

  if (isValidElement(options)) {
    message = options;
  }

  if (typeof options === 'object' && !isValidElement(options)) {
    title = (options as ErrorTip).title || title;
    mode = (options as ErrorTip).mode || mode;
    message = (options as ErrorTip).content;
  }

  if (!message) return;

  if (mode === ErrorTipMode.message) {
    pcMessage.error(message).then(() => {});
  }

  if (mode === ErrorTipMode.notification) {
    notification.error({
      title: title,
      description: message,
    });
  }

  if (mode === ErrorTipMode.modal) {
    confirm({
      title: title,
      content: message,
      okText: t('common:acknowledged'),
    }).then(() => {});
  }
}
